import './events';
import './events-list';
import './events-edit';

import './accreditations/accreditations-list';
import './annexes/events_annexes';
import './budget/budget-list';
import './cms_categories/cms_article_event-edit';
import './cms_categories/cms_article_event-list';
import './cms_categories/cms_categories_event-edit';
import './cms_categories/cms_categories_event-list';
import './common/historicMails';
import './diary/diary';
import './documents/documents-edit';
import './documents/documents-list';
import './groups/groups-list';
import './guests/import/guests-import';
import './guests/actions-menu';
import './guests/guests-list';
import './guests/guestsNotesModal';
import './guests/guestsSpaceZonesModal';
import './guests/guestVehiclesModal';
import './guests/searchGroupModal';
import './historic_mails/historic_mails-list';
import './indicators_types/indicators_types-list';
import './locations/locationsEvents-list';
import './mail_accounts/mail_accounts-list';
import './materials/materials-list';
import './parkings/parkings-list';
import './programs_acts/programs_acts-list';
import './push_notifications/push_notifications_event-edit';
import './push_notifications/push_notifications_event-list';
import './resume/resume-list';
import './spaces/spaces-edit';
import './spaces/spaces-list';
import './staff/staff-list';
import './work_team/work_team-list';
import './tasks/tasks-list';


